import { Injectable } from '@angular/core';
import { SpaContext } from '../../../../Classes/spacontext';
import { VisibaApiHttp } from '../../../../Classes/visibaHttp.class';
import { DropInApiModel } from '../Models/DropInApiModel';

@Injectable()
export class DropInUnitServiceV2 {
	readonly baseUri = '/api/Client/v2/units/';

	constructor(
		private http: VisibaApiHttp,
		public spaContext: SpaContext,
	) {}

	public get(emitLoading = true) {
		return this.http.getTyped<DropInApiModel[]>(
			`${this.baseUri}${this.spaContext.unitConfig.Unit.UnitId}/Dropin`,
			true,
			null,
			emitLoading,
		);
	}

	public getDropInRoom(dropInRoomId: number) {
		return this.http.getTyped<DropInApiModel>(`${this.baseUri}${this.spaContext.unitConfig.Unit.UnitId}/Dropin/${dropInRoomId}`, true);
	}

	public getByUrlAlias(urlAlias: string, unitId: number = null) {
		return this.http.getTyped<DropInApiModel>(
			`${this.baseUri}${unitId || this.spaContext.unitConfig.Unit.UnitId}/Dropin/Url/${urlAlias}`,
			true,
		);
	}
}
